export const AVAILABLE_EMPLOYEE_STATUS = 'Available';
export const UNAVAILABLE_EMPLOYEE_STATUS = 'Unavailable';
